import { render, staticRenderFns } from "./ContactPersonView.vue?vue&type=template&id=4147408c"
import script from "./ContactPersonView.vue?vue&type=script&lang=ts"
export * from "./ContactPersonView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports